module.exports = __webpack_public_path__ + "static/media/normal-yd2.a0d74106.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture/normal-yd2.png
// module id = 1931
// module chunks = 6